import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
export function Footer() {
  const socialLinks = [{
    name: 'Facebook',
    icon: Facebook,
    url: 'http://facebook.com/skillzhq'
  }, {
    name: 'Twitter',
    icon: Twitter,
    url: 'http://twitter.com/skillzhq'
  }, {
    name: 'Instagram',
    icon: Instagram,
    url: 'https://www.instagram.com/myskillzhq?igsh=MWgxbHM1aHNxd3k4Nw=='
  }, {
    name: 'LinkedIn',
    icon: Linkedin,
    url: 'http://linkedin.com/company/skillzhq'
  }];
  return <footer className="bg-gradient-to-b from-white to-gray-50 border-t border-gray-100" data-id="element-295">
      <div className="container mx-auto px-6 lg:px-8 py-16" data-id="element-296">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-297">
          <div data-id="element-298">
            <Link to="/" className="inline-block mb-6" data-id="element-299">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iEDpYjkDJsYJX3g949itDG/logo.png" alt="SkillzHQ" className="h-8 w-auto" data-id="element-300" />
            </Link>
            <p className="text-sm text-gray-600 leading-relaxed" data-id="element-301">
              Empowering professionals and organizations through culture
              transformation and skills development.
            </p>
          </div>

          <div data-id="element-302">
            <h3 className="font-semibold text-gray-900 mb-4 text-sm uppercase tracking-wider" data-id="element-303">
              Company
            </h3>
            <ul className="space-y-3" data-id="element-304">
              <li data-id="element-305">
                <Link to="/about" className="text-sm text-gray-600 hover:text-blue-600 transition-colors duration-200" data-id="element-306">
                  About Us
                </Link>
              </li>
              <li data-id="element-307">
                <Link to="/team" className="text-sm text-gray-600 hover:text-blue-600 transition-colors duration-200" data-id="element-308">
                  Our Team
                </Link>
              </li>
              <li data-id="element-309">
                <Link to="/how-we-execute" className="text-sm text-gray-600 hover:text-blue-600 transition-colors duration-200" data-id="element-310">
                  How We Execute
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-311">
            <h3 className="font-semibold text-gray-900 mb-4 text-sm uppercase tracking-wider" data-id="element-312">
              Learn
            </h3>
            <ul className="space-y-3" data-id="element-313">
              <li data-id="element-314">
                <Link to="/courses" className="text-sm text-gray-600 hover:text-blue-600 transition-colors duration-200" data-id="element-315">
                  Courses
                </Link>
              </li>
              <li data-id="element-316">
                <Link to="/projects" className="text-sm text-gray-600 hover:text-blue-600 transition-colors duration-200" data-id="element-317">
                  Projects
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-318">
            <h3 className="font-semibold text-gray-900 mb-4 text-sm uppercase tracking-wider" data-id="element-319">
              Contact
            </h3>
            <ul className="space-y-3 text-sm text-gray-600" data-id="element-320">
              <li data-id="element-321">
                <a href="mailto:support@myskillzhq.com" className="hover:text-blue-600 transition-colors duration-200" data-id="element-322">
                  support@myskillzhq.com
                </a>
              </li>
              <li data-id="element-323">
                <a href="tel:+2348106836707" className="hover:text-blue-600 transition-colors duration-200" data-id="element-324">
                  0810 683 6707
                </a>
              </li>
              <li className="pt-2" data-id="element-325">
                <div className="flex space-x-3" data-id="element-326">
                  {socialLinks.map(social => {
                  const Icon = social.icon;
                  return <a key={social.name} href={social.url} target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-all duration-300 hover:scale-110" aria-label={social.name} data-id="element-327">
                        <Icon className="w-4 h-4" data-id="element-328" />
                      </a>;
                })}
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-200" data-id="element-329">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-330">
            <p className="text-xs text-gray-500" data-id="element-331">
              © 2025 SkillzHQ. All rights reserved.
            </p>
            <p className="text-xs text-gray-500 mt-2 md:mt-0" data-id="element-332">
              Jeydens Court, Agungi, Lagos
            </p>
          </div>
        </div>
      </div>
    </footer>;
}